<div class="overlay-side-panel"
     [class.collapsed]="isPanelVisible"
     id="{{screenKey}}filterSidePanel">

  <div class="overlay"
       [hidden]="isPanelVisible"
       [@fadeInOut]
       (click)="close()"></div>

  <aside class="side-panel" role="dialog" aria-label="Filters">

    <header class="side-panel__header">
      <h2 class="side-panel__title">Filters</h2>
      <button type="button"
              class="side-panel__close"
              aria-label="Close filters"
              (click)="close()">&times;</button>
    </header>

    <div class="side-panel__body">

      @if (datafiltersLoading) {
<div class="side-panel__loading">
        <div class="loader"></div>
      </div>
}

      @if (!datafiltersLoading) {
<div class="side-panel__filters">

        <div class="filter-field">
          <label class="filter-field__label" for="ddf-tax-year">Year</label>
          <ap-dropdown inputId="ddf-tax-year" class="filter-field__control"
            [list]="getFilterDropdownItems(taxYearList[0]?.data)" [selectType]="'single'"
            [title]="'Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Year'"
            [disabled]="!(taxYearList[0]?.data?.length)"
            [ngModel]="getSelectedFilterItem(taxYearList[0]?.data)"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onFilterDropdownChange($event, taxYearList[0]?.data, 'tax_year')">
            @for (item of getFilterDropdownItems(taxYearList[0]?.data); track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setDropdownAriaLabel(item, 'Year')"
                (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        </div>

        <div class="filter-field">
          <label class="filter-field__label" for="ddf-scenario">Scenario</label>
          <ap-dropdown inputId="ddf-scenario" class="filter-field__control"
            [list]="getFilterDropdownItems(scenarioList[0]?.data)" [selectType]="'single'"
            [title]="'Scenario'" [hideTitleOnInput]="true" [inputAriaLabel]="'Scenario'"
            [disabled]="!(scenarioList[0]?.isLoaded) || !(scenarioList[0]?.data?.length)"
            [ngModel]="getSelectedFilterItem(scenarioList[0]?.data)"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onFilterDropdownChange($event, scenarioList[0]?.data, 'scenario')">
            @for (item of getFilterDropdownItems(scenarioList[0]?.data); track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setDropdownAriaLabel(item, 'Scenario')"
                (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        </div>

        <div class="filter-field">
          <label class="filter-field__label" for="ddf-company">Company</label>
          <ap-dropdown inputId="ddf-company" class="filter-field__control"
            [list]="getFilterDropdownItems(filingGroupList[0]?.data)" [selectType]="'single'"
            [title]="'Company'" [hideTitleOnInput]="true" [inputAriaLabel]="'Company'"
            [disabled]="!(filingGroupList[0]?.isLoaded) || !(filingGroupList[0]?.data?.length)"
            [ngModel]="getSelectedFilterItem(filingGroupList[0]?.data)"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onFilterDropdownChange($event, filingGroupList[0]?.data, 'filing_key')">
            @for (item of getFilterDropdownItems(filingGroupList[0]?.data); track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setDropdownAriaLabel(item, 'Company')"
                (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        </div>

        <div class="filter-field">
          <label class="filter-field__label" for="ddf-system">System</label>
          <ap-dropdown inputId="ddf-system" class="filter-field__control"
            [list]="getFilterDropdownItems(systemList[0]?.data)" [selectType]="'single'"
            [title]="'System'" [hideTitleOnInput]="true" [inputAriaLabel]="'System'"
            [disabled]="!(systemList[0]?.data?.length)"
            [ngModel]="getSelectedFilterItem(systemList[0]?.data)"
            [ngModelOptions]="{standalone: true}"
            (onSelect)="onFilterDropdownChange($event, systemList[0]?.data, 'system')">
            @for (item of getFilterDropdownItems(systemList[0]?.data); track $index) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setDropdownAriaLabel(item, 'System')"
                (onSelectItem)="onFilterSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        </div>

        <div class="filter-field filter-field--business">
          <div class="filter-field__header">
            <span class="filter-field__label">Business</span>
            <div class="filter-field__actions">
              <button type="button" class="link-button" (click)="selectAll(1)">Select All</button>
              <span class="link-button__divider">|</span>
              <button type="button" class="link-button" (click)="unselectAll()">Reset</button>
            </div>
          </div>

          @if (!menuObj1?.isLoaded) {
<div class="side-panel__loading">
            <div class="loader"></div>
          </div>
}

          @if (menuObj1?.isLoaded) {
<div class="business-tree">
            <div class="business-tree__panel customScroll">
              @for (me of menuObj1.data; track $index; let i = $index) {
<div class="business-tree__item"
                  
                   [class.is-active]="me.active">
                <ap-checkbox [(ngModel)]="me.selected"
                            [ngModelOptions]="{standalone: true}"
                            [inputId]="'biz-parent-' + i"
                            [ariaLabel]="me.name"
                            (onChange)="selectedMe($event, me, true)">
                  <span>{{ me.name }}</span>
                </ap-checkbox>
                @if (me.children && me.numSelected > 0) {
<span class="business-tree__count"
                     >{{me.numSelected}}</span>
}
              </div>
}
            </div>

            @if (showSubBusinessMenu && childMenuObj?.length) {
<div class="business-tree__panel business-tree__panel--children customScroll"
                >
              @for (subMe of childMenuObj; track $index; let ii = $index) {
<div class="business-tree__item"
                  >
                <ap-checkbox [(ngModel)]="subMe.selected"
                            [ngModelOptions]="{standalone: true}"
                            [inputId]="'biz-child-' + ii"
                            [ariaLabel]="subMe.name"
                            (onChange)="selectedMe($event, subMe, false)">
                  <span>{{ subMe.name }}</span>
                </ap-checkbox>
                @if (subMe.children) {
<div class="business-tree__subchildren">
                  @for (subChildMe of subMe.children; track $index; let iii = $index) {
<div class="business-tree__item"
                      >
                    <ap-checkbox [(ngModel)]="subChildMe.selected"
                                [ngModelOptions]="{standalone: true}"
                                [inputId]="'biz-grandchild-' + ii + '-' + iii"
                                [ariaLabel]="subChildMe.name"
                                (onChange)="selectedMe($event, subChildMe, false)">
                      <span>{{ subChildMe.name }}</span>
                    </ap-checkbox>
                  </div>
}
                </div>
}
              </div>
}
            </div>
}
          </div>
}
        </div>

      </div>
}
    </div>

    <footer class="side-panel__footer">
      <ap-button [compact]="true"
                 [btnType]="'secondary'"
                 [label]="'Cancel'"
                 [type]="'button'"
                 class="ap-mr-spacing-3"
                 (onClick)="close()"></ap-button>
      <ap-button [compact]="true"
                 [btnType]="'primary'"
                 [label]="'Apply'"
                 [icon]="'filter-outline'"
                 [type]="'button'"
                 (onClick)="filerSave(true)"></ap-button>
    </footer>

  </aside>
</div>
